import React, { useContext, useEffect, useState } from "react";
import { UrlContext } from "../contexts/UrlContext";
import "../styles/UsersApplications.css";
import { UserContext } from "../contexts/UserContext";
import { AppContext } from "../contexts/AppContext";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import loadingicon from "../images/Loading_icon.gif";
import warningIcon from "../images/warningIcon.png";
import errorIcon from "../images/errorRedIcon.png";
import successIcon from "../images/successGreenIcon.png";
import ProjectExpertIsVip from "../components/UserApplication/ProjectExpertIsVip";
import EmailForm from "../components/UserApplication/EmailForm";
import experienceDefault from "../images/nologo.jpeg";

export default function UsersApplications() {
  const { API_URL, URI } = useContext(UrlContext);
  const { userData, scrappingProfiles } = useContext(UserContext);
  const { applications, setApplications, allRequests, setAllRequests } =
    useContext(AppContext);
  const navigate = useNavigate();

  const [pendingRequests, setPendingRequests] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedApplications, setSelectedApplications] = useState([]);
  const [acceptedApp, setAcceptedApp] = useState([]);
  const [rejectedApp, setRejectedApp] = useState([]);
  const [acceptBody, setAcceptBody] = useState([]);
  const [rejectBody, setRejectBody] = useState([]);
  const [english, setEnglish] = useState(true);
  const [requestCheck, setRequestCheck] = useState([]);
  const [sendingConfirmations, setSendingConfirmations] = useState(false);
  const [scrapeProfiles, setScrapeProfiles] = useState(false);
  const [linkedinUser, setLinkedinUser] = useState("");
  const [linkedinPass, setLinkedinPass] = useState("");
  const [loadingScraper, setLoadingScraper] = useState("");
  const [failedScrapes, setFailedScrapes] = useState([]);
  const [error, setError] = useState("");
  const [showEmailPreview, setShowEmailPreview] = useState(false);
  const [emailType, setEmailType] = useState(null);
  const [currentEmailIndex, setCurrentEmailIndex] = useState(0);
  const [requestLoading, setRequestLoading] = useState([]);
  const [animationStatus, setAnimationStatus] = useState({});
  const [fadingRows, setFadingRows] = useState([]);

  const loadApplicationsData = () => {
    setLoading(true);
    const tokenObj = localStorage.getItem("eph-token");
    let token = "";
    if (tokenObj) {
      try {
        token = JSON.parse(tokenObj).value || tokenObj;
      } catch (e) {
        token = tokenObj;
      }
    }
    fetch(`${API_URL}get-all-users-applications`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        if (data.status === "success") {
          setAllRequests([...data.applications]);
          setPendingRequests(
            data.applications.filter((item) => item.status === "pending")
          );
        } else {
          Swal.fire({ title: "Something went wrong", timer: 2000 });
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });

    fetch(`${API_URL}get-users-applications`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "error") {
          Swal.fire({ title: `${data.message}`, icon: "error" });
        } else {
          setApplications(data?.data || []);
        }
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    loadApplicationsData();

    const handleExtensionMessages = (event) => {
      if (event.data?.type === "EPH_APPLICATIONS_SCRAPE_STARTED") {
        Swal.fire({
          title: "Scraping started via Extension",
          text: "The Chrome extension is scraping pending applications in the background.",
          icon: "info",
          timer: 3500,
          showConfirmButton: false,
        });
      } else if (event.data?.type === "applicationsScrapeComplete") {
        const { successCount, failCount } = event.data.data || {};
        Swal.fire({
          title: "Scraping completed",
          text: `Applications processed: ${successCount || 0} saved, ${failCount || 0} failed.`,
          icon: "success",
          timer: 4000,
          showConfirmButton: false,
        });
        loadApplicationsData();
      } else if (event.data?.type === "EPH_RESCRAPE_RESULT") {
        setRequestLoading([]);
        const resp = event.data.response;
        if (resp && resp.success) {
          Swal.fire({
            title: "Re-scrape successful",
            text: "The profile has been updated by the extension.",
            icon: "success",
            timer: 3000,
            showConfirmButton: false,
          });
          loadApplicationsData();
        } else {
          Swal.fire({
            title: "Re-scrape failed",
            text: resp?.error || "Could not update the profile with the extension.",
            icon: "error",
          });
        }
      }
    };

    window.addEventListener("message", handleExtensionMessages);
    return () => {
      window.removeEventListener("message", handleExtensionMessages);
    };
  }, []);

  useEffect(() => {
    if (selectedApplications.length > 0) {
      const acceptArr = [];
      const declineArr = [];
      selectedApplications.forEach((i) => {
        const app = applications.find((item) => item.id === i);
        const greet = english ? "Dear" : "Hi";
        acceptArr.push(
          `${greet} ${app?.name.split(" ")[0]},\n${getAcceptTemplate()}\n`
        );
        declineArr.push(
          `${greet} ${app?.name.split(" ")[0]},\n${getRejectTemplate()}\n`
        );
      });
      setAcceptBody(acceptArr);
      setRejectBody(declineArr);
    }
  }, [selectedApplications, english]);

  const handleCheckboxChange = (itemId) => {
    setSelectedApplications((prevSelected) =>
      prevSelected.includes(itemId)
        ? prevSelected.filter((id) => id !== itemId)
        : [...prevSelected, itemId]
    );
  };

  const handleAcceptOrReject = (id, type) => {
    const selectedApplication = applications.find((app) => app.id === id);
    setSelectedApplications([id]);
    setEmailType(type);
    setCurrentEmailIndex(0);
    setShowEmailPreview(true);
  };

  const handleCloseEmailPreview = () => {
    setShowEmailPreview(false);
    setEmailType(null);
    setSelectedApplications([]);
    setCurrentEmailIndex(0);
  };

  const successAnimation = (id, status) => {
    setRequestLoading((prev) => prev.filter((loadingId) => loadingId !== id));
    setAnimationStatus((prev) => ({
      ...prev,
      [id]: { status, vanishing: false },
    }));

    // Wait for the icon to be shown, then start vanishing it
    setTimeout(() => {
      setAnimationStatus((prev) => ({
        ...prev,
        [id]: { ...prev[id], vanishing: true },
      }));

      if (status === "success") {
        // Start fading out the row
        setFadingRows((prev) => [...prev, id]);

        // Finally remove it after the row animation finishes
        setTimeout(() => {
          setApplications((prevApplications) =>
            prevApplications.filter((app) => app.id !== id)
          );
          setFadingRows((prev) => prev.filter((rowId) => rowId !== id));
          setAnimationStatus((prev) => {
            const newStatus = { ...prev };
            delete newStatus[id];
            return newStatus;
          });
        }, 600); // rowFadeOut duration
      } else {
        // Just clear the animation if it was an error
        setTimeout(() => {
          setAnimationStatus((prev) => {
            const newStatus = { ...prev };
            delete newStatus[id];
            return newStatus;
          });
        }, 500);
      }
    }, 1500); // Time showing the icon before starting to vanish
  };

  const handleSendEmail = async (emailContent) => {
    const user = selectedApplications[0];
    setRequestLoading((prev) => [...prev, user]);
    handleCloseEmailPreview();
    const exist = applications.find((app) => app.id === user)?.exists;
    const tokenObj = localStorage.getItem("eph-token");
    const token = JSON.parse(tokenObj).value;
    const accessToken = localStorage.getItem("accesstoken");

    const fetchFunction = async (api) => {
      try {
        const response = await fetch(`${API_URL}${api}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-access-token": token,
            Authorization: accessToken,
          },
          body: JSON.stringify({ expert: user }),
        });
        const data = await response.json();
        return data;
      } catch (err) {
        console.error(err);
        return { status: "error" };
      }
    };

    const result = await fetchFunction(
      emailType == "reject"
        ? "reject-expert-from-application"
        : exist
        ? "merge-expert-from-application"
        : "add-expert-from-application"
    );

    if (result.status === "success") {
      // If the fetchFunction was successful, send the email
      const emailResult = await sendEmail(emailContent);
      if (emailResult.status === "success") {
        successAnimation(user, "success");
        updateRequestCheck(
          0,
          `${applications.find((app) => app.id === user)?.name} was ${
            emailType == "accept" ? "accepted" : "rejected"
          }`,
          "completed"
        );
      } else {
        successAnimation(user, "error");
        updateRequestCheck(
          0,
          "Request sent (error while sending email)",
          "warning"
        );
      }
    } else {
      successAnimation(user, "error");
      updateRequestCheck(0, "Request Failed", "fail");
    }
  };

  const sendEmail = async (emailContent) => {
    try {
      const response = await fetch(`${API_URL}send-email-with-link-to-client`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(emailContent),
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error while sending email:", error);
      return { status: "error" };
    }
  };

  const updateRequestCheck = (index, message, status) => {
    setRequestCheck((prevRequestCheck) => {
      const newArr = [...prevRequestCheck];
      newArr[index] = { message, status };
      return newArr;
    });
  };

  function escapeHTML(text) {
    const map = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "\n": "<br/>",
    };
    return text.replace(/[&<>"'\n]/g, (m) => map[m]);
  }

  const getAcceptTemplate = () => {
    const buttonHtml = `
      <table width="100%" cellspacing="0" cellpadding="0">
        <tr>
          <td align="center">
            <table cellspacing="0" cellpadding="0">
              <tr>
                <td align="center" style="border-radius: 5px;" bgcolor="#365561">
                  <a href="http://connect.expertpowerhouse.com/" 
                     target="_blank" 
                     style="font-size: 16px; font-family: Helvetica, Arial, sans-serif; color: #ffffff; text-decoration: none; padding: 15px 32px; border: 1px solid #365561; display: inline-block;">
                    Log In
                  </a>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    `;

    return english
      ? `Thank you very much for applying to our network. We are happy to tell you that your application has been reviewed and is successful.\nWelcome to expertpowerhouse!\n\nTo complete your profile please log in to your account at:\n\n${escapeHTML(
          buttonHtml
        )}\n\nYou can use your LinkedIn credentials or request a new password for a first-time login.\nWe are looking forward to collaborating soon and will reach out with matching project opportunities as they come up.\n\nBest regards\n${
          userData?.username
        }`
      : `vielen Dank für deine Bewerbung in unserem Netzwerk. Wir freuen uns, dir mitteilen zu können, dass deine Bewerbung geprüft wurde und erfolgreich ist.\nWillkommen bei expertpowerhouse!\n\nUm dein Profil zu vervollständigen, melde dich bitte unter folgendem Link in deinem Konto an:\nhttp://connect.expertpowerhouse.com/\n\nDas Profil ist bereits mit deinen LinkedIn Daten vorbefüllt, du kannst aber flexibel Änderungen vornehmen. Du kannst deine LinkedIn-Anmeldedaten verwenden oder ein neues Passwort für die erstmalige Anmeldung anfordern. Wir freuen uns auf die baldige Zusammenarbeit und werden uns mit passenden Projektmöglichkeiten bei dir melden, sobald diese verfügbar sind.\nViele Grüße\n${userData?.username}`;
  };

  const getRejectTemplate = () => {
    return english
      ? `Thank you very much for your application to become a member of the expertpowerhouse network.\nYour application has been reviewed and we have to regrettably tell you that we cannot consider it at this point in time as we do not have enough business in your area of expertise.\nWe wish you all the best for your future and hope that our paths cross again at a later stage.\n\nBest regards\n${userData?.username}`
      : `vielen Dank für Ihre Bewerbung als Mitglied des expertpowerhouse-Netzwerks.\nIhre Bewerbung wurde geprüft und wir müssen Ihnen leider mitteilen, dass wir sie zum jetzigen Zeitpunkt nicht berücksichtigen können, da wir nicht genügend Projekte in Ihrem Fachgebiet haben.\nWir wünschen Ihnen alles Gute für Ihre Zukunft und hoffen, dass sich unsere Wege zu einem späteren Zeitpunkt wieder kreuzen werden.\n\nMit freundlichen Grüßen\n${userData?.username}`;
  };

  const rescrapeProfile = (id, url) => {
    setRequestLoading((prev) => [...prev, id]);

    const targetApp = applications.find((a) => a.id === id || a.ID === id);
    const resolvedUrl = url || targetApp?.linkedinURL || targetApp?.link || targetApp?.url || "";

    // Dispatch event to Chrome Extension (via inject.js)
    window.dispatchEvent(
      new CustomEvent("eph-trigger-rescrape", {
        detail: { preexpert_id: id, id: id, url: resolvedUrl, link: resolvedUrl, linkedinURL: resolvedUrl },
      })
    );

    // Timeout safety in case extension is not loaded
    setTimeout(() => {
      setRequestLoading((prev) => prev.filter((loadingId) => loadingId !== id));
    }, 20000);
  };

  const deleteApplication = (id) => {
    setRequestLoading((prev) => [...prev, id]);
    fetch(`${API_URL}delete-preexpert`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          const newarr = [...applications];
          setApplications(newarr.filter((item) => item.id != id));
        } else {
          Swal.fire({ title: "Something went wrong", icon: "error" });
        }
        setRequestLoading((prev) => prev.filter((loadingId) => loadingId !== id));
      });
  };

  return (
    <>
      <div className="users-applications-container">
        <div className="users-pending-requests">
          {scrappingProfiles ? (
            <img
              src={loadingicon}
              style={{ width: "40px", height: "40px" }}
              alt="Loading"
            />
          ) : (
            <div className="users-pending-details">
              {pendingRequests.length > 0 ? (
                <>
                  <span>
                    <span
                      style={{
                        padding: "3px 8px",
                        borderRadius: "100%",
                        backgroundColor: "#365561",
                        color: "white",
                      }}
                    >
                      {pendingRequests.length}
                    </span>
                    <span className="ml-2">pending requests to scrape </span>
                    <button
                      className="btn"
                      style={{ color: "#365561" }}
                      disabled={scrappingProfiles}
                      onClick={() => {
                        window.dispatchEvent(
                          new CustomEvent("eph-trigger-applications-scrape")
                        );
                        Swal.fire({
                          title: "Scraping started via Extension",
                          text: "The Chrome extension is processing pending requests in the background.",
                          icon: "info",
                          timer: 3500,
                          showConfirmButton: false,
                        });
                      }}
                    >
                      {scrappingProfiles ? "SCRAPPING..." : "SCRAPE"}
                    </button>
                  </span>
                  <div style={{ display: "flex", flexDirection: "row" }}></div>
                </>
              ) : (
                <span>No pending requests to scrape</span>
              )}
              <span
                onClick={() => navigate("applications-info")}
                style={{ color: "blue", cursor: "pointer" }}
              >
                + more info
              </span>
            </div>
          )}
        </div>

        {applications.length === 0 ? (
          <h3>No applications pending to review</h3>
        ) : (
          applications.map((item) => {
            if (item.status === "pending") {
              return (
                <div
                  className={`${
                    requestLoading.includes(item.id)
                      ? "users-applications-item-loading"
                      : "users-applications-item"
                  } ${fadingRows.includes(item.id) ? "fading-out" : ""}`}
                  key={item.id}
                  style={{ position: "relative" }}
                >
                  {animationStatus[item.id] && (
                    <div
                      className={`animation-overlay ${
                        animationStatus[item.id].vanishing ? "vanishing" : ""
                      }`}
                    >
                      <img
                        src={
                          animationStatus[item.id].status === "success"
                            ? successIcon
                            : errorIcon
                        }
                        className="animation-icon"
                        alt={animationStatus[item.id].status}
                      />
                    </div>
                  )}
                  <div style={{ width: "100%" }}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "90%",
                      }}
                    >
                      <input
                        className="mr-3"
                        type="checkbox"
                        checked={selectedApplications.includes(item.id)}
                        onChange={() => handleCheckboxChange(item.id)}
                      />
                      <img
                        src={item.profilePicture}
                        className="prjdetails-con-img"
                        style={{ borderRadius: "50%" }}
                        alt={`${item.name}'s profile`}
                      />
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginLeft: "10px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <a
                            className="prjdetails-con-name"
                            href={item.linkedinURL}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {item.name}
                          </a>
                          <ProjectExpertIsVip
                            isVip={item.isVip}
                            expert_id={item.id}
                          />
                        </div>
                        <span>{item.location}</span>
                        <span>
                          {item.cons_exp ? item.cons_exp.toUpperCase() : null}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="users-application-summ">{item.summ}</div>
                  <div className="users-application-experience">
                    {item.experience.split("\n\n").map((exp, index) => {
                      if (exp) {
                        return (
                          <React.Fragment key={index}>
                            <img
                              src={
                                item[`logo${index + 1}`] || experienceDefault
                              }
                              width={"50px"}
                              style={{
                                gridColumn: "1",
                                justifySelf: "center",
                              }}
                              alt={`Logo ${item + 1}`}
                            />
                            <span
                              style={{
                                gridColumn: "2",
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <span key={index}>{exp}</span>
                            </span>
                          </React.Fragment>
                        );
                      }
                      return null;
                    })}
                  </div>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateRows: "0.3fr 1fr",
                      justifyContent: "center",
                      height: "100%",
                    }}
                  >
                    <div className="users-applications-buttons">
                      <button
                        className="btn"
                        onClick={() =>
                          rescrapeProfile(item.id, item.linkedinURL)
                        }
                      >
                        Re-scrape
                      </button>
                      <button
                        onClick={() => deleteApplication(item.id)}
                        className="btn"
                        title="Delete"
                      >
                        X
                      </button>
                    </div>
                    <div className="users-applications-buttons">
                      <button
                        className="btn"
                        onClick={() => handleAcceptOrReject(item.id, "accept")}
                      >
                        {item.exists ? "Merge" : "Accept"}
                      </button>
                      <button
                        onClick={() => handleAcceptOrReject(item.id, "reject")}
                        className="btn"
                      >
                        Decline
                      </button>
                    </div>
                  </div>
                </div>
              );
            }
            return null;
          })
        )}
      </div>

      {showEmailPreview && selectedApplications.length > 0 && (
        <EmailForm
          key={selectedApplications[0]}
          projectID={null}
          type={emailType}
          language={english ? "EN" : "DE"}
          onClose={handleCloseEmailPreview}
          onSend={handleSendEmail}
          initialContent={
            emailType === "accept"
              ? acceptBody[currentEmailIndex]
              : rejectBody[currentEmailIndex]
          }
          userData={userData}
          applicantName={
            applications.find((app) => app.id === selectedApplications[0]).name
          }
          applicantEmail={
            applications.find((app) => app.id === selectedApplications[0]).email
          }
        />
      )}

      {sendingConfirmations && (
        <div
          className="modal"
          tabIndex="-1"
          role="dialog"
          style={{ display: "flex", backdropFilter: "blur(5px)" }}
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content" style={{ width: "500px" }}>
              <div className="modal-body">
                <div className="request-check-modal">
                  {requestCheck.map((item, index) => (
                    <span key={index} className="request-check-modal-span">
                      <span>{item.message}</span>
                      <img
                        src={
                          item.status === "completed"
                            ? successIcon
                            : item.status === "fail"
                            ? errorIcon
                            : item.status === "warning"
                            ? warningIcon
                            : loadingicon
                        }
                        style={{ height: "20px", width: "20px" }}
                        alt={`Status ${item.status}`}
                      />
                    </span>
                  ))}
                </div>
              </div>
              <div className="modal-footer">
                {requestCheck.filter((item) => item.status === "pending")
                  .length === 0 && (
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-dismiss="modal"
                    onClick={() => {
                      setSendingConfirmations(false);
                      setRequestCheck([]);
                      setAcceptedApp([]);
                      setRejectedApp([]);
                      setSelectedApplications([]);
                    }}
                  >
                    Close
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
